import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectLinks } from '../../../../_lib/components/SelectLinks/SelectLinks';
import { Namespace } from '../../../../translation/namespace';
import { FacetLink } from './FacetLink';

type FilterEventTypeProps = { eventStartDate?: FacetLink[] };

export function FilterEventType(props: FilterEventTypeProps) {
  const { t } = useTranslation(Namespace.FilterEventType);

  if (!props.eventStartDate) {
    return null;
  }

  const selectedSort = props.eventStartDate.find(item => item.url === null);

  const mappedDatesWithTranslations = props.eventStartDate.map(item => ({
    ...item,
    name: t(`sortOptions.${item.name}`),
  }));

  return (
    <div className="filter-event-type">
      <SelectLinks headline={t('sortOptions.headline')} links={mappedDatesWithTranslations} />
      {props.eventStartDate?.length === 0
        ? null
        : (
            <input type="hidden" name="fq_eventEndDate" value={selectedSort ? selectedSort.name : ''} />
          )}
    </div>
  );
}
